module.exports = {"360425100":"涂埠镇（赣江新区永修组团）","360425101":"吴城镇","360425102":"三溪桥镇","360425103":"虬津镇","360425104":"艾城镇","360425105":"滩溪镇","360425106":"白槎镇","360425107":"梅棠镇","360425108":"燕坊镇","360425109":"马口镇","360425110":"柘林镇","360425200":"三角乡","360425201":"九合乡","360425202":"立新乡","360425203":"江上乡","360425404":"江西永修云山经济技术开发区（赣江新区永修组团）","360425500":"云山企业集团","360425501":"恒丰企业集团","360425502":"八角岭垦殖场","360425503":"永丰垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360425.json
// module id = 1270
// module chunks = 0